import axios from 'axios';
import store from '../../state/store';
import { refreshTokenAction } from '../../sagas/auth/refreshAccessToken/action';

const cirrusClient = axios.create({
    baseURL: 'https://cirrus.blinkcomet.com/ns-api/',
});

cirrusClient.interceptors.request.use(
    async (config) => {
        // Access the Redux store to get the current state
        const state = store.getState();
        const accessToken = state.userCredential.access_token;
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        // Set Content-Type to application/json only for POST requests
        if (config.method === 'post' && !config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    (error) => Promise.reject(error)
);

cirrusClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Dispatch the action
                store.dispatch(refreshTokenAction());

                // Wait for the new token using subscription
                const newAccessToken = await new Promise((resolve,reject) => {
                    const unsubscribe = store.subscribe(() => {
                        const state = store.getState();
                        if (state.userCredential.access_token) {
                            unsubscribe();
                            resolve(state.userCredential.access_token);
                        }
                    });

                    // Timeout to reject the promise if the token is not updated within a certain time
                    setTimeout(() => {
                        unsubscribe();
                        reject(new Error('Token refresh timeout'));
                    }, 5000); // Adjust timeout duration as needed
                });
                if (newAccessToken) {
                    originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return cirrusClient(originalRequest);
                }
            } catch (refreshError) {
                // Handle refresh failure (e.g., redirect to login)
                // Optionally, dispatch an action to clear the auth state and redirect to login
                // store.dispatch(logoutAction());
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default cirrusClient;